import { render, staticRenderFns } from "./ModularApp.vue?vue&type=template&id=7d4e44ee&"
import script from "./ModularApp.vue?vue&type=script&lang=js&"
export * from "./ModularApp.vue?vue&type=script&lang=js&"
import style0 from "./ModularApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports